import { AxiosInstance } from 'axios';
import { createContextAwareHandlers } from './instance';

interface PersonalSubscriptionParams {
  interval?: string;
  category?: string;
  type?: string;
  description?: string;
  items?: SubscriptionItem[];
  metadata?: Metadata;
  cancelAtPeriodEnd?: boolean;
}

interface PersonalSubscriptionResponse {
  subscription: SubscriptionObject;
  orderId: string;
}

interface Metadata {
  customer: {
    gender: string;
  };
}

export const create = (instance: AxiosInstance) => async (
  subData: PersonalSubscriptionParams,
  customerId: string,
): Promise<PersonalSubscriptionResponse> => {
  const { data } = await instance.post<PersonalSubscriptionResponse>(`/customers/${customerId}/subscriptions`, subData);

  return data;
};

export const update = (instance: AxiosInstance) => async (
  subscriptionId: string,
  subData: PersonalSubscriptionParams,
  customerId: string,
): Promise<PersonalSubscriptionResponse> => {
  const { data } = await instance.put<PersonalSubscriptionResponse>(`/customers/${customerId}/subscriptions/${subscriptionId}`, subData);

  return data;
};

export const remove = (instance: AxiosInstance) => async (subscriptionId: string, customerId: string): Promise<PersonalSubscriptionResponse> => {
  const { data } = await instance.put<PersonalSubscriptionResponse>(`/customers/${customerId}/subscriptions/${subscriptionId}`, {
    cancelAtPeriodEnd: true,
  });

  return data;
};

const handlers = {
  create,
  update,
  remove,
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createPersonalSubscriptionApi = (context: PortalContext) => {
  return createContextAwareHandlers(context, handlers);
};

export default createPersonalSubscriptionApi;
